<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Subscriber Log</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
          <label for=""><span class="text-danger">* </span><u>Date Type</u></label>
          <select #selectedFlag class="form-control" placeholder="" (change)="changeFlag(selectedFlag.value)">
            <option *ngFor="let flag of flagList | keyvalue" [value]="flag.value" [selected]="flag.key == selectedFlag">{{flag.key}}</option>
          </select>
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword"  (ngModelChange)="changeKeyword($event)">
          <option value=null selected>-select keyword-</option>
          <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw.keyword}}</option>
        </select>
      </div>
      <div class="col" *ngIf="affiliateList != null && affiliateList.length > 0">
        <label for=""><u>Filter by Affiliate</u> Special:
          <i class="fas" placement="right" ngbTooltip="'NULL': affiliate is null before affiliate is enabled">'NULL'</i>
          &nbsp;<i class="fas" placement="right" ngbTooltip="'-': it's default value when affiliate is null after affiliate is enabled">'-'</i>
        </label>
        <select [(ngModel)]="filterable.affiliate" class="form-control" placeholder="Affiliate">
          <option value='' selected>-select affiliate-</option>
          <option *ngFor="let af of affiliateList" [ngValue]="af">{{af}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Phone</u></label>
        <input type="text" [(ngModel)]="filterable.phone" class="form-control" placeholder="enter phone" />
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->
  <div class="col text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="subList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>ID</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>Phone</th>
      <th>Interval</th>
      <th>Reference</th>
      <th>Active</th>
      <th>Subscribe Date</th>
      <th>Unsubscribe Date</th>
      <th>Withheld</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="13">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="13">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let sub of subRecords; index as i;">
      <td>{{sub.id}}</td>
      <td>{{sub.shortCode}}</td>
      <td>{{sub.keyword}}</td>
      <td>{{sub.operator}}</td>
      <td>{{sub.phone}}</td>
      <td>{{sub.interval}}</td>
      <td class="text-left">
          <span class="font-italic font-weight-bold">Affiliate:</span>  {{sub.affiliate}} <br>
          <span class="font-italic font-weight-bold">ClickId:</span>  {{sub.clickId}} <br>
          <span class="font-italic font-weight-bold">Ref:</span>  {{sub.reference}} <br>
          <span class="font-italic font-weight-bold">Channel:</span>  {{sub.channel}}
      </td>
      <td>
        <span *ngIf="sub.active">TRUE</span>
        <span *ngIf="sub.active == false" class="text-danger">FALSE</span>
      </td>
      <td>{{sub.subscribeDate}}</td>
      <td>{{sub.unsubscribeDate}}</td>
      <td>
        <div *ngIf="sub.withheld"><span  class="text-danger font-weight-bold">TRUE</span><br> {{sub.withheldMsg}}</div>
        <div *ngIf="sub.withheld == false">FALSE</div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="13" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
